module.exports = ".table-height-padding-sm td {\n  padding-top: 0.4em;\n  padding-bottom: 0.4em;\n  font-size: 14px; }\n\n.text {\n  display: block;\n  width: 100px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  font-style: normal;\n  color: #007bff; }\n\n.pointer {\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-main/components/public-applicants-list/public-applicants-list.component.scss
// module id = ./src/app/modules/common-main/components/public-applicants-list/public-applicants-list.component.scss
// module chunks = main